import { Box, Grid2, TextField } from "@mui/material";
import { useState } from "react";
import "./SubjectTest.css";
import { useLocation, useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import useNavigationGuard from "../../../../hooks/useNavigationGuard";
import {
  createDrugTypeService,
  updateDrugTypeService,
} from "../../../../services/drugTypeManagementService";
import { notifyError, notifySuccess } from "../../../../utilities/helper";
import Loader from "../../../../components/Loader";
import { CreateHandleUnsaveNavigation } from "../../../../utilities/handleUnsaveNavigation";
import SearchableSelect from "../../../../components/SearchableSelect";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { HandleUnsaveNavigationWithFun } from "../../../../utilities/handleUnsaveNavigationWithFun";

const SubjectTest = () => {
  const id = useLocation()?.state?.id;

  const [load, setLoad] = useState(false);
  const [subjectName, setSubjectName] = useState("");
  const [testSubjectNumber, setTestSubjectNumber] = useState("");

  const navigate = useNavigate();

  const access_token = localStorage?.getItem("access_token");
  const role = localStorage.getItem("role");

  const handleUnsaveNavigation = CreateHandleUnsaveNavigation();
  const handleUnSaveWithFun = HandleUnsaveNavigationWithFun();

  const visitScreeningCreateSchema = yup.object().shape({
    visitDate: yup
      .mixed()
      .test("is-valid-date", "Visit Date is required", (value) =>
        dayjs(value).isValid()
      )
      .nullable(),
    weight: yup
      .string()
      .matches(/^\d+(\.\d+)?$/, "Weight is not valid.")
      .required("Weight is required"),
    bodyTemperature: yup
      .string()
      .matches(/^\d+(\.\d+)?$/, "Body Temperature is not valid.")
      .required("Body Temperature is required"),
    comments: yup.string().required("Doctor's comment is required"),
    visitStatus: yup.string().required("Visit Status"),
  });

  const {
    register,
    control,
    handleSubmit,
    reset,
    formState: { errors, isDirty },
  } = useForm({
    resolver: yupResolver(visitScreeningCreateSchema),
    defaultValues: {
      bodyTemperature: "",
      comments: "",
      visitDate: "",
      visitStatus: "",
      weight: "",
    },
  });

  useNavigationGuard(isDirty);

  const addVisitScreeningData = async (data) => {
    setLoad(true);
    const newData = {
      ...data,
    };

    try {
      if (!id) {
        const res = await createDrugTypeService(access_token, newData);
        if (res?.data?.status == 409) {
          setLoad(false);
          notifyError("Data Correction already exists !");
          return;
        } else if (res?.status == 200) {
          setLoad(false);
          notifySuccess("Data Correction is created successfully !");
          reset();
          navigate("/update-subject");
        }
      } else {
        const res = await updateDrugTypeService(access_token, newData, id);
        if (res?.status == 200) {
          setLoad(false);
          notifySuccess("Data Correction is Updated successfully !");
          reset();
          navigate("/update-subject");
        }
      }
    } catch (err) {
      setLoad(false);
      console.log(err.message);
      notifyError(err.message);
      if (err.status == 401) {
        navigate("/unAuthorize");
      }
    }
  };

  const bodyTemperatureRegister = register("bodyTemperature");
  const weightRegister = register("weight");

  return (
    <>
      {load ? (
        <Loader />
      ) : (
        <div className="content-body">
          <p className="bread-crumbs-link-container">
            <button
              className="bread-crumbs-btn"
              onClick={(e) => handleUnsaveNavigation(e, isDirty, "", navigate)}
            >
              Home
            </button>{" "}
            |{" "}
            <button
              className="bread-crumbs-btn"
              onClick={(e) =>
                handleUnsaveNavigation(e, isDirty, "subject", navigate)
              }
            >
              Subject Management
            </button>
            {" | "}
            <button
              className="bread-crumbs-btn"
              onClick={(e) =>
                handleUnSaveWithFun(
                  e,
                  isDirty,
                  () => navigate("/update-subject", { state: { id: id } }),
                  () => {}
                )
              }
            >
              {subjectName}
            </button>{" "}
            |{" "}
            <button
              className="bread-crumbs-btn"
              to="/subject-randomization-treatment"
            >
              Test
            </button>
            -{" "}
            <b style={{ color: "gray" }}>
              {localStorage?.getItem("studyName")}
            </b>
          </p>
          <Grid2
            container
            alignItems="center"
            justifyContent="space-between"
            sx={{ width: "100%", margin: "0 auto" }}
          >
            <Grid2 item md={12}>
              <p className="page-heading">Test Details</p>
            </Grid2>
          </Grid2>

          <div className="subject-test-container">
            <div className="subject-test-inner-container">
              <p className="subject-test-heading">Test</p>
              <span>S-10001-001</span>
              <span>Scheduled Visit</span>
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "250px 10px 1fr",
                rowGap: "5px",
                alignItems: "center",
              }}
            >
              <div>Previously Completed Visit Name</div>
              <div>:</div>
              <div>Screening</div>

              <div>Previously Completed Visit Date</div>
              <div>:</div>
              <div>10-Jan-2024</div>
            </div>
          </div>

          <Box
            component="form"
            autoComplete="off"
            sx={{ height: "auto", width: "100%" }}
            onSubmit={handleSubmit(addVisitScreeningData)}
          >
            <Grid2
              container
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", marginBottom: "-40px" }}
            >
              <Grid2 item md={12}>
                <p className="page-heading">Screening Visit</p>
              </Grid2>
            </Grid2>
            <Grid2
              container
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", marginBottom: "2" }}
            >
              <Grid2 item md={12}>
                <p
                  className="page-heading"
                  style={{ fontSize: "small", marginBottom: "-20px" }}
                >
                  Patient Number {testSubjectNumber}
                </p>
                <p className="page-heading" style={{ fontSize: "small" }}>
                  Patient Name {subjectName}
                </p>
              </Grid2>
            </Grid2>
            <Grid2
              container
              alignItems="center"
              justifyContent={"space-between"}
              sx={{ width: "100%", margin: "0 auto" }}
              gap={1}
            >
              <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
                <div>
                  <p className="labelStyles">Visit Date</p>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Controller
                      name="visitDate"
                      control={control}
                      rules={{ required: "Visit Date is required" }} // Optional validation rule
                      render={({ field }) => (
                        <DatePicker
                          sx={{ width: "100%" }}
                          value={field.value ? dayjs(field.value) : null}
                          onChange={(date) => field.onChange(date)}
                          format="DD-MMM-YYYY"
                          minDate={dayjs()}
                          slotProps={{
                            textField: {
                              placeholder: "DD-MMM-YYYY",
                              sx: {
                                "& .MuiInputBase-root": { height: "40px" },
                              },
                              size: "small",
                              fullWidth: true,
                            },
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </div>
                {errors.visitDate && (
                  <div className="error-container">
                    {errors.visitDate.message}
                  </div>
                )}
              </Grid2>
              <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
                <div>
                  <p className="labelStyles">
                    Weight (kg)
                    <span>*</span>
                  </p>
                  <TextField
                    fullWidth
                    size="small"
                    type={"text"}
                    {...weightRegister}
                    onChange={(e) => {
                      let value = e.target.value;

                      // Allow only digits and one dot
                      value = value.replace(/[^0-9.]/g, ""); // Remove everything except digits and dot
                      value = value.replace(/^0+(?!\.)/, ""); // Remove leading zeros unless it's "0."
                      const parts = value.split(".");

                      if (parts.length > 2) {
                        // More than one dot is not allowed
                        value = parts[0] + "." + parts.slice(1).join("");
                      }

                      e.target.value = value;
                      weightRegister.onChange(e);
                    }}
                  />
                </div>
                {errors.weight && (
                  <div className="error-container">{errors.weight.message}</div>
                )}
              </Grid2>

              <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
                <div>
                  <p className="labelStyles">
                    Body Temperature (°C)
                    <span>*</span>
                  </p>
                  <TextField
                    fullWidth
                    size="small"
                    type={"text"}
                    {...bodyTemperatureRegister}
                    onChange={(e) => {
                      let value = e.target.value;

                      // Allow only digits and one dot
                      value = value.replace(/[^0-9.]/g, ""); // Remove everything except digits and dot
                      value = value.replace(/^0+(?!\.)/, ""); // Remove leading zeros unless it's "0."
                      const parts = value.split(".");

                      if (parts.length > 2) {
                        // More than one dot is not allowed
                        value = parts[0] + "." + parts.slice(1).join("");
                      }

                      e.target.value = value;
                      bodyTemperatureRegister.onChange(e);
                    }}
                  />
                </div>
                {errors.bodyTemperature && (
                  <div className="error-container">
                    {errors.bodyTemperature.message}
                  </div>
                )}
              </Grid2>
              <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
                <div>
                  <p className="labelStyles">
                    Visit Status
                    <span>*</span>
                  </p>
                  <SearchableSelect
                    control={control}
                    data={[]}
                    name={"visitStatus"}
                    optionKey="id"
                    optionLabel="name"
                  />
                </div>
                {errors.visitStatus && (
                  <div className="error-container">
                    {errors.visitStatus.message}
                  </div>
                )}
              </Grid2>

              <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
                <div>
                  <p className="labelStyles">
                    Doctor's Comments
                    <span>*</span>
                  </p>
                  <TextField
                    fullWidth
                    size="large"
                    type={"text"}
                    {...register("comments")}
                  />
                </div>
                {errors.comments && (
                  <div className="error-container">
                    {errors.comments.message}
                  </div>
                )}
              </Grid2>
            </Grid2>

            <Grid2
              alignItems={"end"}
              justifyContent="end"
              container
              gap={3}
              sx={{ marginTop: "2%" }}
            >
              <Grid2 item md={6}>
                <button
                  type="button"
                  className="create-btn-outlined"
                  onClick={(e) => {
                    e.preventDefault();
                    handleUnSaveWithFun(
                      e,
                      isDirty,
                      () => navigate("/update-subject", { state: { id: id } }),
                      () => {}
                    );
                  }}
                >
                  Cancel
                </button>
              </Grid2>
              <Grid2 item md={6}>
                <button type="submit" className="create-btn">
                  Save
                </button>
              </Grid2>
            </Grid2>
          </Box>
        </div>
      )}
    </>
  );
};

export default SubjectTest;
